import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { startCase } from 'lodash-es';
import type { StyleObj } from '../../@types';
import type { Withdrawal } from '../../@types/api';
import { getApprovalStatusColor } from '../../utils';
import { mergeSx } from '../../utils/styles';
import { getZeroXStatusNotice, WITHDRAWAL_STATE_LABELS } from './ZeroXWithdrawalDetails';

const styles: StyleObj = {
  root: { flexDirection: 'row', alignItems: 'center', gap: 1, height: '100%' },
  label: { typography: { xs: 'body3', md: 'body2' } },
};

const statusColor = (color: string): StyleObj[string] => ({ color });

/** One owner for how an approval's status reads: label, color and an optional provider notice. */
export const getWithdrawalStatusPresentation = (withdrawal: Withdrawal) => ({
  label: withdrawal.cryptoWithdrawal
    ? WITHDRAWAL_STATE_LABELS[withdrawal.cryptoWithdrawal.state]
    : startCase(withdrawal.status),
  color: getApprovalStatusColor(withdrawal.status),
  notice: getZeroXStatusNotice(withdrawal.cryptoWithdrawal),
});

const WithdrawalStatusCell = ({ withdrawal }: { withdrawal: Withdrawal }) => {
  const { label, color, notice } = getWithdrawalStatusPresentation(withdrawal);

  return (
    <Stack sx={styles.root}>
      {/* The notice comes first so a non-wrapping, narrow cell never clips it. */}
      {notice && (
        <Tooltip title={notice.hint}>
          <Chip size='small' color='warning' label={notice.label} aria-label={notice.hint} />
        </Tooltip>
      )}
      <Typography sx={mergeSx(styles.label, statusColor(color))}>{label}</Typography>
    </Stack>
  );
};

export default WithdrawalStatusCell;
